// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N600 } from '@atlaskit/theme/colors';
import { fontFamily, fontSize } from '@atlaskit/theme/constants';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormNameWrapper = styled.div({
  fontFamily: fontFamily(),
  fontSize: fontSize(),
  lineHeight: '24px',
  display: 'flex',
  alignItems: 'center',
  color: `var(--ds-text-subtle, ${N600})`,
  whiteSpace: 'pre-wrap',
  textAlign: 'left'
});